import { useMemo } from 'react'

import { selectAccessibleEmployees } from '@/redux/employee-selector'
import { useAppSelector } from '@/redux/utils'

export default function useSelectedEmployees(employeeIds: number[]) {
  const employees = useAppSelector(selectAccessibleEmployees)
  const { selectedEmployees, employeeNames } = useMemo(() => {
    const selected = employees.filter(({ id }) => employeeIds.includes(id))
    return {
      selectedEmployees: selected,
      employeeNames: selected.map(({ name }) => name).join(', '),
    }
  }, [employeeIds, employees])

  return { selectedEmployees, employeeNames }
}
